import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function ReCaptchaTerms(t0) {
  const $ = _c(28);
  let other;
  let sx;
  if ($[0] !== t0) {
    ({
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
  } else {
    other = $[1];
    sx = $[2];
  }
  const {
    t
  } = useTranslate();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      textAlign: "start",
      typography: "caption",
      color: "text.secondary"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== sx) {
    t2 = Array.isArray(sx) ? sx : [sx];
    $[4] = sx;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = [t1, ...t2];
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = `${t("This site is protected by reCAPTCHA, the")} `;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "inherit"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("Terms of service");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Box component="a" target="_blank" rel="noopener noreferrer" href="https://policies.google.com/terms" sx={t5}>{t6}</Box>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(" and ");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      color: "inherit"
    };
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("Privacy policy");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <Box component="a" target="_blank" rel="noopener noreferrer" href="https://policies.google.com/privacy" sx={t9}>{t10}</Box>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = ` ${t("from Google will be applicable")}.`;
  let t13;
  if ($[20] !== other || $[21] !== t11 || $[22] !== t12 || $[23] !== t3 || $[24] !== t4 || $[25] !== t7 || $[26] !== t8) {
    t13 = <Box sx={t3} {...other}>{t4}{t7}{t8}{t11}{t12}</Box>;
    $[20] = other;
    $[21] = t11;
    $[22] = t12;
    $[23] = t3;
    $[24] = t4;
    $[25] = t7;
    $[26] = t8;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}